import React from 'react';
import { connect } from 'react-redux';
import { ListTypeDocumentTemplate } from '../../Templates';
import {
  apiGetDocumentsById,
  apiGetSpVieDocument
} from '../../Api/Documents/Documents';
class ListTypeDocument extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: { value: '', text: '' },
      data: [
        {
          text: 'Contrat_GAV_PDF'
        },
        {
          text: 'Contrat_DecesAccident_PDF'
        }
      ],
      docList: [],
      emptyDocListMsg: '',
      file: {
        attachement: '',
        blob: '',
        url: ''
      },
      documentSelected: '',
      step: 1
    };
  }

  componentDidMount() {
    const type = this.props.match.params.type;
    if (type === this.props.doc.name) {
      this.setState({
        type: {
          value: this.props.doc,
          text: this.props.doc.name
        }
      });
      this.getDocumentList(this.props.doc.id);
    } else {
      this.props.history.push('/documents');
    }
  }

  getDocumentList = async (id) => {
    console.log('ID', id);
    const res = await apiGetDocumentsById(id);
    console.log('RESSS GET DOCUMENT LIST', res);
    if (res.status === 200) {
      this.setState({
        docList: res.data
      });
    } else {
      this.setState({
        docList: [],
        emptyDocListMsg: res.errors?.[0] || ["Une erreur s'est produite"]
      });
    }
  };

  onDowLoad = async (el) => {
    if (el.content) {
      const { blob, url } = await this.createBlob(el.content);
      this.setState({
        file: {
          attachement: el,
          blob: blob,
          url: `${url}`
        }
      });
      if (url) {
        const download = document.createElement('a');
        download.setAttribute('href', url);
        download.setAttribute('target', '_blank');
        download.click();
      }
    } else {
      const res = await apiGetSpVieDocument(el.attachmentInfoId);
      if (res.status === 200) {
        const { blob, url } = await this.createBlob(
          res.base64pdf,
          res.mimeType
        );
        this.setState({
          file: {
            attachement: res,
            blob: blob,
            url: `${url}`,
            mimeType: res.mimeType
          }
        });
        if (url) {
          const download = document.createElement('a');
          download.setAttribute('href', url);
          download.setAttribute('target', '_blank');
          download.click();
        }
      }
    }
  };

  onOpen = async (el) => {
    if (el.content) {
      const { blob, url } = await this.createBlob(el.content);
      this.setState({
        documentSelected: el,
        step: 2,
        file: {
          attachement: el,
          blob: blob,
          url: `${url}`
        }
      });
    } else {
      const res = await apiGetSpVieDocument(el.attachmentInfoId);
      console.log('RES ON OPEN', res);
      if (res.status === 200) {
        const { blob, url } = await this.createBlob(
          res.base64pdf,
          res.mimeType
        );
        this.setState({
          documentSelected: el,
          step: 2,
          file: {
            attachement: res,
            blob: blob,
            url: `${url}`,
            mimeType: res.mimeType
          }
        });
      }
    }
  };

  createBlob = async (data, mimeType = 'application/pdf') => {
    try {
      const blob = await (
        await fetch(`data:${mimeType};base64,${data}`)
      ).blob();
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (err) {}
  };

  onReturn = () => {
    if (this.state.step === 1) {
      this.props.history.push('/documents');
    } else {
      this.setState({ step: 1 });
    }
  };

  
  render() {
    return (
      <ListTypeDocumentTemplate
        state={this.state}
        history={this.props.history}
        onOpen={this.onOpen}
        onDowLoad={this.onDowLoad}
        onReturn={this.onReturn}
      />
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: (action) => {
      dispatch(action);
    }
  };
};
const mapStateToProps = (state) => ({
  doc: state.DocumentsReducer.data
});
export default connect(mapStateToProps, mapDispatchToProps)(ListTypeDocument);
